import { Component, Prop, h, Event, EventEmitter, Method } from '@stencil/core';

/**
 * AdSelect is a select component that can be used to replace the native select element.
 * @slot - Default slot for select options
 */
@Component({
  tag: 'ad-select',
  styleUrl: 'ad-select.css',
  scoped: true
})


export class AdessoSelect {

    selectbox: HTMLSelectElement;
    /** Name / identifier of formfield */
    @Prop({reflect:true}) name: string;
    @Prop({reflect:false, mutable:true}) isOpen: boolean = false;
    /** Equivalent of onChange on HTMLSelectElement */
    @Event() selectChange: EventEmitter<{ name:string, value:string }>;

    /** Set the selectedIndex to 0 */
    @Method() 
    async reset() {
        this.selectbox.selectedIndex = 0;
    }

    onChangeHandler(event) {
        this.isOpen = false;
        this.selectChange.emit({ name: this.name, value: event.target.value });
    }

    selectMousePress = () => {
      this.isOpen = !this.isOpen;
    }

    selectBlurHandle = () => {
      this.isOpen = false;
    }

    onClickHandler = () => {
      if(!this.isOpen) {
        this.isOpen = true;
        this.selectbox.focus();
        this.selectbox.showPicker();
      } else {
        this.selectbox.blur();
        this.isOpen = false;
      }
      
    }

  render() {
    return(
        <div class="selectbox-container">
            <select name={this.name} onChange={this.onChangeHandler.bind(this)} onMouseDown={this.selectMousePress.bind(this)} onBlur={this.selectBlurHandle.bind(this)} ref={selectbox => this.selectbox = selectbox as HTMLSelectElement}>
                <slot></slot>
            </select>
            <button onClick={this.onClickHandler.bind(this)} aria-label="toggle dropdown" aria-controls="selectbox" aria-expanded={this.isOpen}>
              <ad-icon icon={this.isOpen ? "chevron-up" : "chevron-down"}></ad-icon>
            </button>   
        </div>
    );
  }
}
